import type {
  BulkUpdateProgramManagementPathwayStagesDtoType,
  EnableProgramManagementPathwayDtoType,
  ProgramManagementPathwayListItemDtoType,
  ProgramManagementPathwayLiveSitesDtoType,
  ProgramManagementSiteDetailDtoType,
  ProgramManagementSiteListItemDtoType,
  RegisterProgramManagementSiteDtoType,
} from '@tempus/trials-types';

import axios from '../axios';
import { TRIALS_NEST_API_ROOT } from '../constants';

export const programManagementApi = {
  getSitesList: async (): Promise<ProgramManagementSiteListItemDtoType[]> => {
    const { data } = await axios.get<ProgramManagementSiteListItemDtoType[]>(
      `${TRIALS_NEST_API_ROOT}/program-management/sites`,
    );
    return data;
  },
  exportSites: async (search: string): Promise<Blob> => {
    const query = search.trim();
    const { data } = await axios.get<Blob>(`${TRIALS_NEST_API_ROOT}/program-management/sites/export`, {
      ...(query ? { params: { search: query } } : {}),
      responseType: 'blob',
    });
    return data;
  },
  registerSite: async (siteId: string): Promise<ProgramManagementSiteListItemDtoType> => {
    const body: RegisterProgramManagementSiteDtoType = { siteId };
    const { data } = await axios.post<ProgramManagementSiteListItemDtoType>(
      `${TRIALS_NEST_API_ROOT}/program-management/sites`,
      body,
    );
    return data;
  },
  getPathwaysList: async (): Promise<ProgramManagementPathwayListItemDtoType[]> => {
    const { data } = await axios.get<ProgramManagementPathwayListItemDtoType[]>(
      `${TRIALS_NEST_API_ROOT}/program-management/pathways`,
    );
    return data;
  },
  getSiteDetail: async (siteId: string): Promise<ProgramManagementSiteDetailDtoType> => {
    const { data } = await axios.get<ProgramManagementSiteDetailDtoType>(
      `${TRIALS_NEST_API_ROOT}/program-management/sites/${siteId}`,
    );
    return data;
  },
  enablePathwayAtSite: async (
    pathwayId: string,
    params: EnableProgramManagementPathwayDtoType,
  ): Promise<ProgramManagementSiteDetailDtoType> => {
    const { data } = await axios.post<ProgramManagementSiteDetailDtoType>(
      `${TRIALS_NEST_API_ROOT}/program-management/pathways/${pathwayId}/enable`,
      params,
    );
    return data;
  },
  bulkUpdatePathwayStages: async (
    pathwayId: string,
    params: BulkUpdateProgramManagementPathwayStagesDtoType,
  ): Promise<ProgramManagementSiteDetailDtoType> => {
    const { data } = await axios.post<ProgramManagementSiteDetailDtoType>(
      `${TRIALS_NEST_API_ROOT}/program-management/pathways/${pathwayId}/stages/bulk-update`,
      params,
    );
    return data;
  },
  getPathwayLiveSites: async (pathwayId: string): Promise<ProgramManagementPathwayLiveSitesDtoType> => {
    const { data } = await axios.get<ProgramManagementPathwayLiveSitesDtoType>(
      `${TRIALS_NEST_API_ROOT}/program-management/pathways/${pathwayId}/live-sites`,
    );
    return data;
  },
};
